export const GA4_MEASUREMENT_ID = "G-D0035RJE3S";

type Ga4ParameterValue = string | number | boolean;
type Ga4Parameters = Record<string, Ga4ParameterValue>;
type Gtag = (command: "event", eventName: string, parameters?: Ga4Parameters) => void;

declare global {
  interface Window {
    gtag?: Gtag;
  }
}

function sendGa4Event(eventName: string, parameters?: Ga4Parameters) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return false;
  window.gtag("event", eventName, parameters);
  return true;
}

export function trackGa4PageView() {
  if (typeof window === "undefined" || typeof document === "undefined") return false;
  return sendGa4Event("page_view", {
    page_title: document.title,
    page_location: `${window.location.origin}${window.location.pathname}`,
  });
}

export function trackGa4PhoneClick() {
  return sendGa4Event("phone_click");
}

export function trackGa4CalculatorGuideDownload() {
  return sendGa4Event("calculator_guide_download", { guide_type: "partition_budget" });
}

export function trackGa4Lead(source: "quote_request" | "callback_request") {
  return sendGa4Event("generate_lead", { lead_source: source });
}
